import type { NskResponse } from '~/models/Api';
import { postRequest } from '../api_handler';
import { generatePath } from '~/utils/generatePath';

export const create = async (email: string): Promise<NskResponse<void>> =>
  postRequest(generatePath('/vendors/vendor_company_password_resets'), {
    email
  });
